import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Tab, Col, Nav, NavItem, Panel } from 'react-bootstrap';
import { } from 'react-bootstrap';
import _ from 'lodash';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';
import withForm from '../../hoc/withForm';
import Permission from '../../components/Permission/Permission';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';

import Spinner from '../../components/Spinner/Spinner';

import { columns, sorting } from './RSAMenuSettingsSchema';
import * as constants from '../../constants';
import { useRSAMenuSettingsStore } from '../../store/providers/RSAMenuSettings';

const BaseList = React.lazy(() => import('../../components/Lists/BaseList/BaseList'));
const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));

const RSAMenuSettings = (props) => {
    const dispatch = useDispatch();
    const pagePermission = constants.PERMISSION_SETTINGS_RSA_MENU_SETTINGS;

    const { data, selectedRSAMenuSettingsTab, setSelectedRSAMenuSettings, listRecords, setRSAMenuPreference } = useRSAMenuSettingsStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [listData, setListData] = useState([]);
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const listChanged = (_id, value, item, _row) => {
        if (_id == 'isEnabled') {
            updateEnabledStatus(_row, value, true);
        }
    }

    const updateEnabledStatus = (row, value, isCheckboxEvent = false) => {
        setRSAMenuPreference({ menuId: row.id, instanceTypeId: selectedRSAMenuSettingsTab, isEnabled: value });
        setTimeout(() => {
            let allPermissions = listData.map(obj => {
                if (obj.id === row.id) {
                    return { ...obj, isEnabled: value };
                }
                return obj;
            });
            setListData(allPermissions);
        }, 300);
    };

    const tabContent = () => {
        return (
            <>
                <Row>
                    <Col sm={12}>
                        <div style={{ paddingRight: '15px' }}>
                            <Panel>
                                <Panel.Body>
                                    <BaseList
                                        compType="RSA Settings"
                                        keyField="id"
                                        listData={listData}
                                        isBusy={isBusy}
                                        sorting={sorting}
                                        columns={columns}
                                        hideCopy={true}
                                        hideRefresh={true}
                                        hidePrint={true}
                                        hideFilter={true}
                                        hideDelete={true}
                                        hasCheckbox={true}
                                        hideAdd={true}
                                        hideEdit={true}
                                        hidePagination={true}
                                        showActions={false}
                                        permissionEdit={canEdit}
                                        changed={(id, value, item, row) => listChanged(id, value, item, row)}
                                    />
                                </Panel.Body>
                            </Panel>
                        </div>
                    </Col>
                </Row>
            </>
        )
    }

    const tabSelectedHandler = (tabKey) => {
        setSelectedRSAMenuSettings(tabKey);

        setTimeout(() => {
            setListData([]);
            listRecords({ instanceTypeId: tabKey });
        }, 100);
    };

    useEffect(() => {
        if (isMounted && !_.isEmpty(data)) {
            if (!_.isEmpty(data.body)) {
                if (data.status === 'success' && data.scope === 'list') {
                    setListData(data.body.rsaMenu);
                    setIsLoaded(true);
                }
            }

            setIsBusy(data.status === 'processing' && data.scope === 'list');
        }

    }, [data, isMounted]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }

        dispatch(breadcrumbAddRoute({ key: 'rsaMenuSettings', parent: 'Settings', text: 'RSA Settings' }));

        setIsMounted(true);
        listRecords({ instanceTypeId: constants.INSTANCE_TYPE.Corporate });
        setSelectedRSAMenuSettings(constants.INSTANCE_TYPE.Corporate);
    }, [isMounted, hasPermission, dispatch]);

    return (
        <>
            <SideMenu activeKey="settings" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isMounted &&
                    <>
                        <PageHeader title="RSA Settings" />
                        {
                            !isLoaded && <Spinner text="Loading RSA Settings..." />
                        }
                        {
                            isLoaded &&
                            <div style={{ paddingRight: '15px' }}>
                                <Tab.Container id="rsaMenuSettingsByInstanceType" defaultActiveKey={constants.INSTANCE_TYPE.Corporate} activeKey={selectedRSAMenuSettingsTab} onSelect={tabSelectedHandler}>
                                    <Row className="clearfix">
                                        <Col sm={12}>
                                            <Nav bsStyle="pills">
                                                <NavItem eventKey={constants.INSTANCE_TYPE.Corporate} disabled={isBusy}>Corporate</NavItem>
                                                <NavItem eventKey={constants.INSTANCE_TYPE.NonCorporate} disabled={isBusy}>Non-Corporate</NavItem>
                                                <NavItem eventKey={constants.INSTANCE_TYPE.BrokerOps} disabled={isBusy}>BrokerOps</NavItem>
                                            </Nav>
                                        </Col>
                                        <Col sm={12}>
                                            <Tab.Content animation>
                                                <Tab.Pane eventKey={constants.INSTANCE_TYPE.Corporate}>
                                                    {tabContent()}
                                                </Tab.Pane>
                                                <Tab.Pane eventKey={constants.INSTANCE_TYPE.NonCorporate}>
                                                    {tabContent()}
                                                </Tab.Pane>
                                                <Tab.Pane eventKey={constants.INSTANCE_TYPE.BrokerOps}>
                                                    {tabContent()}
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Col>
                                    </Row>
                                </Tab.Container>
                            </div>
                        }
                    </>
                }
            </div>
        </>
    )
}

export default withAuthentication(withLayout(withForm(RSAMenuSettings)));